import React, { useState } from 'react';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';

const RegisterForm = ({ onToggleMode }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
  });
  const [errors, setErrors] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    general: ''
  });
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    // Очищаем ошибку при вводе
    if (errors[name] || errors.general) {
      setErrors({
        ...errors,
        [name]: '',
        general: ''
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({ name: '', email: '', password: '', confirmPassword: '', general: '' });

    // Валидация на клиенте
    if (formData.password !== formData.confirmPassword) {
      setErrors({
        ...errors,
        confirmPassword: 'Пароли не совпадают'
      });
      return;
    }

    if (formData.password.length < 6) {
      setErrors({
        ...errors,
        password: 'Пароль должен содержать минимум 6 символов'
      });
      return;
    }

    setLoading(true);
    const result = await register(formData.name, formData.email, formData.password);
    
    if (result.success) {
      onToggleMode();
      alert('Регистрация успешна! Пожалуйста, войдите в систему.');
    } else {
      setErrors({
        ...errors,
        general: result.error
      });
    }
    
    setLoading(false);
  };

  return (
    <Form onSubmit={handleSubmit}>
      {errors.general && (
        <Alert variant="danger" className="mb-3">
          {errors.general}
        </Alert>
      )}
      
      <Form.Group className="mb-3">
        <Form.Label>Имя пользователя</Form.Label>
        <Form.Control
          type="text"
          name="name"
          placeholder="Введите ваше имя"
          value={formData.name}
          onChange={handleChange}
          required
          minLength="1"
          maxLength="100"
          size="lg"
          isInvalid={!!errors.name}
        />
        <Form.Control.Feedback type="invalid">
          {errors.name}
        </Form.Control.Feedback>
      </Form.Group>
      
      <Form.Group className="mb-3">
        <Form.Label>Email</Form.Label>
        <Form.Control
          type="email"
          name="email"
          placeholder="Введите ваш email"
          value={formData.email}
          onChange={handleChange}
          required
          size="lg"
          isInvalid={!!errors.email}
        />
        <Form.Control.Feedback type="invalid">
          {errors.email}
        </Form.Control.Feedback>
      </Form.Group>
      
      <Form.Group className="mb-3">
        <Form.Label>Пароль</Form.Label>
        <Form.Control
          type="password"
          name="password"
          placeholder="Минимум 6 символов"
          value={formData.password}
          onChange={handleChange}
          required
          minLength="6"
          size="lg"
          isInvalid={!!errors.password}
        />
        <Form.Control.Feedback type="invalid">
          {errors.password}
        </Form.Control.Feedback>
      </Form.Group>
      
      <Form.Group className="mb-3">
        <Form.Label>Подтвердите пароль</Form.Label>
        <Form.Control
          type="password"
          name="confirmPassword"
          placeholder="Повторите ваш пароль"
          value={formData.confirmPassword}
          onChange={handleChange}
          required
          size="lg"
          isInvalid={!!errors.confirmPassword}
        />
        <Form.Control.Feedback type="invalid">
          {errors.confirmPassword}
        </Form.Control.Feedback>
      </Form.Group>
      
      <Button 
        type="submit"
        variant="primary"
        size="lg"
        className="w-100"
        disabled={loading}
      >
        {loading ? (
          <>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              className="me-2"
            />
            Регистрация...
          </>
        ) : (
          'Зарегистрироваться'
        )}
      </Button>
      
      <div className="text-center mt-3">
        <span className="text-muted">Уже есть аккаунт? </span>
        <Button 
          variant="link" 
          onClick={onToggleMode}
          className="p-0 text-decoration-none"
        >
          Войти
        </Button>
      </div>
    </Form>
  );
};

export default RegisterForm;